import { BaseModel } from "./baseModel";

export class ProceedingsViewingOptions extends BaseModel {

    sessionTitle: boolean;
    letterGrouping: boolean;
    abbreviatedName: boolean;

}
